import script from "./TopBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopBar.vue?vue&type=script&lang=ts&setup=true"

import "./TopBar.vue?vue&type=style&index=0&id=ce521510&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce521510"]])

export default __exports__